import Layout from "../../components/layout/Layout";
import React, { useEffect, useState } from "react";
import { useGetAnalystListQuery } from "../../redux/service/modules/dashboard";
import CoverageSpreadTable from "../../containers/CoverageSpreadTable";
import SectorBarChart from "../../containers/SectorCoverageChart";
import { CoverageUniverseChart } from "../../containers/CoverageUniverseChart";
import CommonNavigator from "../../components/common/CommonNavigator";

const Performance = () => {
    const { data: analystList } = useGetAnalystListQuery();
    const [filters, setFilters] = useState([]);

    const updateAnalystFilters = () => {
        if (analystList) {
            const analystFilter = {
                name: "analystName",
                label: "Analyst Name",
                key: "analyst",
                options: analystList.map((analyst) => ({
                    label: analyst.username,
                    id: analyst.id,
                })),
                multiSelect: true,
            };
            setFilters((filters) => {
                const filtersCpy = [...filters];
                filtersCpy.push(analystFilter);
                return filtersCpy;
            });
        }
    };

    useEffect(() => {
        updateAnalystFilters(analystList);
    }, [analystList]);

    return (
        <Layout disableHeaderSelection={true}>
            <div className="flex flex-col gap-2">
                <CommonNavigator title={"Performance"} />
                <div className="grid grid-cols-2 gap-2 auto-rows-auto">
                    <div className="h-full bg-white rounded-lg shadow-sm pb-2">
                        <CoverageSpreadTable filters={filters} />
                    </div>
                    <div className="h-full bg-white rounded-lg shadow-sm pb-2">
                        <SectorBarChart filters={filters} />
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm pb-2">
                    <CoverageUniverseChart />
                </div>
            </div>
        </Layout>
    );
};

export default Performance;
